import React, { useState, useEffect } from 'react';

export default function LoadingScreen() {
  const [visible, setVisible] = useState(true);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFading(true), 2400);
    const t2 = setTimeout(() => setVisible(false), 3200);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, []);

  if (!visible) return null;

  return (
    <>
      <style>{`
        .lux-loader {
          position: fixed;
          inset: 0;
          z-index: 9999;
          background:
            radial-gradient(circle at center, rgba(201,169,110,0.16), transparent 34%),
            linear-gradient(135deg, #6B1B2A, #3A0B15);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          opacity: ${fading ? 0 : 1};
          transition: opacity 0.8s ease;
          pointer-events: none;
        }

        .jewel-box {
          width: 150px;
          height: 110px;
          position: relative;
          perspective: 700px;
        }

        .box-base {
          position: absolute;
          bottom: 0;
          left: 16px;
          width: 118px;
          height: 62px;
          background: linear-gradient(135deg, #7A2233, #3A0B15);
          border: 1px solid rgba(201,169,110,0.55);
          border-radius: 10px 10px 18px 18px;
          box-shadow: 0 18px 35px rgba(0,0,0,0.3);
        }

        .box-lid {
          position: absolute;
          bottom: 55px;
          left: 14px;
          width: 122px;
          height: 48px;
          background: linear-gradient(135deg, #8F2C42, #4B101C);
          border: 1px solid rgba(201,169,110,0.55);
          border-radius: 18px 18px 8px 8px;
          transform-origin: bottom center;
          animation: lidOpen 2.1s ease-in-out infinite;
        }

        .box-gold-line {
          position: absolute;
          left: 30px;
          bottom: 38px;
          width: 90px;
          height: 2px;
          background: linear-gradient(90deg, transparent, #E5C27A, transparent);
        }

        .diamond-ring {
          position: absolute;
          left: 50%;
          bottom: 35px;
          transform: translateX(-50%);
          width: 54px;
          height: 54px;
          border: 5px solid #C9A96E;
          border-radius: 50%;
          box-shadow: 0 0 20px rgba(201,169,110,0.55);
          animation: ringRise 2.1s ease-in-out infinite;
        }

        .diamond-ring::before {
          content: "";
          position: absolute;
          top: -19px;
          left: 50%;
          transform: translateX(-50%) rotate(45deg);
          width: 22px;
          height: 22px;
          background: linear-gradient(135deg, #FFF6D4, #C9A96E);
          box-shadow: 0 0 18px rgba(255,246,212,0.85);
        }

        .loader-shine {
          position: absolute;
          width: 130px;
          height: 2px;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.9), transparent);
          bottom: 92px;
          left: 10px;
          animation: shineMove 2.1s ease-in-out infinite;
        }

        .loader-brand {
          margin-top: 28px;
          font-family: "Cormorant Garamond", serif;
          font-size: 34px;
          color: #C9A96E;
          letter-spacing: 4px;
          animation: fadeUp 1s ease 0.3s both;
        }

        .loader-sub {
          margin-top: 8px;
          font-family: "Jost", sans-serif;
          color: #D8B979;
          font-size: 11px;
          letter-spacing: 6px;
          text-transform: uppercase;
          animation: fadeUp 1s ease 0.55s both;
        }

        @keyframes lidOpen {
          0%, 100% { transform: rotateX(0deg); }
          45%, 70% { transform: rotateX(-62deg); }
        }

        @keyframes ringRise {
          0%, 100% { opacity: 0; transform: translateX(-50%) translateY(18px) scale(0.75); }
          45%, 70% { opacity: 1; transform: translateX(-50%) translateY(-10px) scale(1); }
        }

        @keyframes shineMove {
          0% { transform: translateX(-50px); opacity: 0; }
          45% { opacity: 1; }
          100% { transform: translateX(50px); opacity: 0; }
        }

        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div className="lux-loader">
        <div className="jewel-box">
          <div className="box-lid" />
          <div className="loader-shine" />
          <div className="diamond-ring" />
          <div className="box-base" />
          <div className="box-gold-line" />
        </div>

        <div className="loader-brand">Anvith Dazzle</div>
        <div className="loader-sub">Luxury Jewellery</div>
      </div>
    </>
  );
}